import {
    DrawerHeader,
    DrawerHeaderTitle,
    OverlayDrawer,
    Button,
    useRestoreFocusSource,
    makeStyles,
    Tooltip,
} from "@fluentui/react-components";

import { Dismiss20Regular, Dismiss20Filled, Delete20Regular, Delete20Filled, bundleIcon } from "@fluentui/react-icons";

const DismissBundle = bundleIcon(Dismiss20Filled, Dismiss20Regular);
const RemoveBundle = bundleIcon(Delete20Filled, Delete20Regular);

const useStyles = makeStyles({
    title: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
    },
});

type BaseCategoryDrawerProps = {
    title: string;
    icon: JSX.Element;
    size: "medium" | "small" | "large" | "full" | undefined;
    isOpen: boolean;
    close: () => void;
    removable?: boolean;
    remove?: () => void;
    children: React.ReactNode;
};

export default function BaseCategoryDrawer({ title, icon, size, isOpen, close, removable, remove, children }: BaseCategoryDrawerProps) {
    const restoreFocusSourceAttributes = useRestoreFocusSource();
    const styles = useStyles();

    return (
        <OverlayDrawer
            {...restoreFocusSourceAttributes}
            size={size}
            open={isOpen}
            position="end"
        >
            <DrawerHeader>
                <DrawerHeaderTitle
                    action={
                        <>
                            {
                                removable &&
                                <Tooltip content="Delete" relationship="label">
                                    <Button
                                        appearance="subtle"
                                        shape="circular"
                                        aria-label="Delete"
                                        icon={<RemoveBundle />}
                                        onClick={remove}
                                    />
                                </Tooltip>
                            }

                            <Tooltip content="Close" relationship="label">
                                <Button
                                    appearance="subtle"
                                    shape="circular"
                                    aria-label="Close"
                                    icon={<DismissBundle />}
                                    onClick={close}
                                />
                            </Tooltip>
                        </>
                    }
                >
                    <div className={styles.title}>
                        {icon}{title}
                    </div>
                </DrawerHeaderTitle>
            </DrawerHeader>

            {children}
        </OverlayDrawer>
    );
}
